import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.jsx";
import "./styles.css";
import { createKeycloak } from "./auth/keycloak.js";

const keycloak = createKeycloak();

// Inicializar Keycloak sem forçar login (permite acesso público)
keycloak
  .init({ onLoad: "check-sso", checkLoginIframe: false })
  .then(() => {
    const root = ReactDOM.createRoot(document.getElementById("root"));
    root.render(
      <React.StrictMode>
        <BrowserRouter>
          <App keycloak={keycloak} />
        </BrowserRouter>
      </React.StrictMode>
    );
  })
  .catch((error) => {
    console.error("Falha ao inicializar Keycloak", error);
    // Renderizar mesmo se Keycloak falhar (modo público)
    const root = ReactDOM.createRoot(document.getElementById("root"));
    root.render(
      <React.StrictMode>
        <BrowserRouter>
          <App keycloak={null} />
        </BrowserRouter>
      </React.StrictMode>
    );
  });
